import * as Sentry from "@sentry/browser";
import { API_BASE_URL, TOKENS_VERSION } from "config/env";
import { tokenInfoResponseSchema } from "generated-schemas-tokens";
import { useQuery } from "react-query";
import { CHAINS } from "config/chains";
import { Chain } from "viem";
import { z } from "zod";

export const useTokenlistMetadataByChain = (args: { chainId: Chain["id"] }) => {
  return useQuery(["tokenlistMetadata", args], {
    queryFn: ({ queryKey }) =>
      getTokenlistMetadataByChain((queryKey[1] as { chainId: Chain["id"] }).chainId),
  });
};

const tokenlistMetadataSchema = z.record(tokenInfoResponseSchema);
export type TokenListMetadata = z.infer<typeof tokenlistMetadataSchema>;
const getTokenlistMetadataByChain = async (chainId: Chain["id"]) => {
  const chainName = CHAINS[chainId].apiName;
  const fetchUrl = `${API_BASE_URL}/tokens/${TOKENS_VERSION}/${chainName}/prices/all`;

  try {
    const tokenlistMetadataByChainRaw = await (await fetch(fetchUrl)).json();
    const metadataForChainResult = tokenlistMetadataSchema.safeParse(tokenlistMetadataByChainRaw);
    if (!metadataForChainResult.success) {
      throw new Error("Cannot parse tokenlist metadata.");
    }
    return Promise.resolve(metadataForChainResult.data);
  } catch (error) {
    const errorString = JSON.stringify(error);
    console.error(`Failed retrieving token metadata at ${fetchUrl}, error: ${errorString}`);
    Sentry.captureException(`Failed retrieving token metadata at ${fetchUrl}`, {
      extra: { error: errorString },
    });
    return Promise.reject(errorString);
  }
};
